import gql from 'graphql-tag';

export default gql`
  query findHomeTaskWorkspaceLessonQuery($_id: MongoID!) {
    findByIdLessonQuery(_id: $_id) {

      _id
      id
      title
      data {
        student
        course
        courseCategory
        homeTaskStatus
        isZeroLesson
      }
      workOnHomeTask {
        notes
      }
      homeTask {
        _id
        title
        notes
        filesStatuses {
          file
          status
          updatedAt
          updatedBy
        }
        files {
          _id
          name
          description
          interactionIcon
          path
          type
          data {
            isNotHandout
            isLink
          }
        }
      }

    }
  }
`;
